import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const StatsCards = ({ dashboardData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const stats = [
    { count: dashboardData?.totalDispatched, label: t('dashboard.totalDispatched'), route: "/dashboard/order-container" },
    { count: dashboardData?.totalPending, label: t('dashboard.totalPending'), route: "/dashboard/total-pending" },
    { count: dashboardData?.totalInTransit, label: t('dashboard.totalInTransit'), route: "/dashboard/total-transit-list" },
    { count: dashboardData?.totalDelivered, label: t('dashboard.totalDelivered'), route: "/dashboard/total-delivered" },
  ];

  return (
    <div className="flex flex-wrap justify-center sm:justify-start pb-4 gap-4 bg-[#0D0E2C] px-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          onClick={() => stat.route && navigate(stat.route)}
          className={`w-full sm:w-1/2 md:w-1/3 lg:w-[230px] h-[120px] rounded-md bg-[#1D2461] flex flex-col items-center shadow-md 
            ${stat.route ? "cursor-pointer hover:scale-105 transition" : ""}
          `}
        >
          <div className="relative flex items-center justify-center mt-1">
            <div className="absolute w-[80px] h-[20px] rounded-full bg-[#00f0ff] blur-[30px] opacity-90"></div>
            <div className="text-4xl font-inter font-bold text-white z-10">
              {stat.count}
            </div>
          </div>
          <div className="text-xl text-white text-center leading-tight mt-1">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;